import React from 'react';
import {
  AuditOutlined,
  DashboardOutlined,
  ExportOutlined,
  SafetyCertificateOutlined,
  SettingFilled,
  ShoppingCartOutlined,
  ToolFilled,
  FunnelPlotOutlined,
  UserOutlined,
  MailOutlined,
  InboxOutlined,
  LineChartOutlined
} from '@ant-design/icons';
import { useHandleClick } from '@/components/UserOptions/hooks';
import { USER_ACTION_TYPE } from '@/components/UserOptions/constants';

/**
 * Navigation define all the routes and link that
 * will be render in the sidebar or navbar(depending of the layout)
 *
 * It can be an
 * {Array} Use array when yo have group sections, like Main, Admin , etc
 * Ex: [{title:'name', menu:[...],}, ....]
 *
 * {Object} Use object when yo don't have section , it is just one,
 * Ex: {menu: [.....]}
 * */

export const navigation = [
  {
    title: 'main',
    menu: [
      {
        title: 'products',
        link: '/products',
        icon: <DashboardOutlined />,
        menu: []
      },
      {
        title: 'categories',
        link: '/categories',
        icon: <AuditOutlined />,
        menu: []
      },
      {
        title: 'orders',
        link: '/orders',
        icon: <ShoppingCartOutlined />,
        menu: []
      },
      {
        title: 'statusOrder',
        link: '/status-orders',
        icon: <FunnelPlotOutlined/>,
        menu: []
      },
      {
        title: 'pages',
        link: '/pages',
        icon: <ToolFilled />,
        menu: []
      },
      {
        title: 'supportmessages',
        link: '/supportmessages',
        icon: <MailOutlined />,
        menu: []
      },
      {
        title: 'subscriptions',
        icon: <InboxOutlined />,
        menu: [
          {
            link: '/subscriptions',
            permissions: ['USER.READ']
          },
          {
            link: '/template-email',
            permissions: ['USER.READ']
          }
        ]
      },
    ]
  },
  {
    title: 'admin',
    path: '/admin', // we use path to append it as prefix to the menu children
    menu: [
      {
        title: 'statistics',
        path: '/statistics',
        icon: <LineChartOutlined />,
        menu: [
          {
            link: '/inventory',
            permissions: ['USER.READ']
          },
          {
            link: '/orders',
            permissions: ['USER.READ']
          },
        ]
      },
      {
        title: 'security',
        icon: <SafetyCertificateOutlined />,
        menu: [
          {
            link: '/users',
            permissions: ['USER.READ']
          },
          {
            link: '/access-requests',
            permissions: ['USER.READ']
          },
        ]
      },
      {
        title: 'setting',
        path: '/setting',
        icon: <SettingFilled />,
        menu: [
          {
            link: '/general',
            permissions: ['ADMIN']
          },
          {
            link: '/auth',
            permissions: ['ADMIN']
          },
          {
            link: '/navigation',
            permissions: ['ADMIN']
          },
          {
            link: '/seo',
            permissions: ['ADMIN']
          },
          {
            link: '/social',
            permissions: ['ADMIN']
          },
          // {
          //   link: '/orders',
          //   permissions: ['ADMIN']
          // },
          // {
          //   title: 'statusOrder',
          //   link: '/status-orders',
          //   permissions: ['ADMIN']
          // },
        ]
      },
    ]
  },
];

export const userOptions = {
  options: [],
  userActions: {
    viewType: USER_ACTION_TYPE.POPUP,
    showInfo: true,
    options: [
      {
        divider: true
      },
      {
        title: 'profile',
        action: 'PROFILE',
        icon: <UserOutlined />,
      },
      {
        divider: true
      },
      {
        title: 'logout',
        action: 'LOGOUT',
        icon: <ExportOutlined />,
      }
    ],
  },
  useHandleClick
};
